interface TablePlainDataCellProps {
    children: React.ReactElement;
    dataLabel: string | number | undefined;
}

export default ({ children, dataLabel }: TablePlainDataCellProps) => {
    return (
        <td className="px-3 py-3 border-b border-gray-200 bg-white text-sm" data-label={dataLabel}>
            {children}
        </td>
    );
};
